import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/search?q=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20anime%20style%20cherry%20blossom%20landscape%20with%20soft%20pink%20petals%20floating%2C%20warm%20sunset%20sky%2C%20distant%20temple%2C%20dreamy%20atmosphere%2C%20soft%20bokeh%20effect%2C%20pastel%20color%20palette%2C%20romantic%20scenery%2C%20no%20text%2C%20clean%20composition&width=1600&height=700&seq=hero-bg-sakura&orientation=landscape"
        alt="樱花动漫91 - 漫画全集下拉式阅读"
        title="樱花动漫91漫画全集下拉式在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 text-center">
        <h1 className="font-heading text-3xl md:text-5xl text-white mb-3 drop-shadow-lg">
          樱花动漫91
        </h1>
        <p className="text-white/90 text-base md:text-lg mb-8 max-w-[600px] mx-auto leading-relaxed">
          漫画全集下拉式阅读体验，海量在线漫画资源，好看的漫画免费在线看，每日更新最新漫画章节
        </p>

        <form onSubmit={handleSearch} className="flex items-center max-w-[520px] mx-auto mb-10">
          <div className="relative flex-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <i className="ri-search-line text-lg text-foreground-400 w-5 h-5 flex items-center justify-center"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索你喜欢的漫画..."
              className="w-full pl-11 pr-4 py-3.5 bg-white/95 backdrop-blur-sm rounded-l-full text-sm text-foreground-950 placeholder-foreground-400 outline-none border-0 focus:ring-2 focus:ring-primary-400"
              aria-label="搜索漫画"
            />
          </div>
          <button
            type="submit"
            className="px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-white rounded-r-full text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <span className="text-white/70 text-sm whitespace-nowrap">热门搜索：</span>
          {['星辰之恋', '烈焰战神', '龙之契约', '机甲学院', '校园爆笑日记'].map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="px-3 py-1.5 bg-white/15 hover:bg-white/25 text-white/90 text-sm rounded-full transition-colors duration-200 whitespace-nowrap backdrop-blur-sm"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}